import { createEntityAdapter, EntityAdapter, EntityState } from "@ngrx/entity";
import { QueryParamsModel } from "../../_base/crud";
import { RetailBuildingAdjustmentActions, RetailBuildingAdjustmentsActionTypes } from "../_actions/retail-building-adjustment.actions";
import { RetailBuildingAdjustmentModel } from "../_models/retail-building-adjustment.model";

export interface RetailBuildingAdjustmentsState extends EntityState<RetailBuildingAdjustmentModel> {
    isAllAdjustmentsLoaded: boolean;
    queryRowsCount: number;
    queryResult: RetailBuildingAdjustmentModel[];
    lastCreatedAdjustmentId: number;
    listLoading: boolean;
    actionLoading: boolean;
    totalCount: number;
    totalTrashed: number;
    totalAdminTrashed: number;

    lastQuery: QueryParamsModel;
    showInitWaitingMessage: boolean;
}

export const adapter: EntityAdapter<RetailBuildingAdjustmentModel> = createEntityAdapter<RetailBuildingAdjustmentModel>();

export const initialAdjustmentsState: RetailBuildingAdjustmentsState = adapter.getInitialState({
    isAllAdjustmentsLoaded: false,
    queryRowsCount: 0,
    queryResult: [],
    lastCreatedAdjustmentId: undefined,
    listLoading: false,
    actionLoading: false,
    totalCount: 0,
    totalTrashed: 0,
    totalAdminTrashed: 0,
    lastQuery: new QueryParamsModel({}),
    showInitWaitingMessage: true
});

export function retailBuildingAdjustmentssReducer(state = initialAdjustmentsState, action: RetailBuildingAdjustmentActions): RetailBuildingAdjustmentsState {
    switch (action.type) {
        case RetailBuildingAdjustmentsActionTypes.RetailBuildingAdjustmentsPageToggleLoading:
            return {
                ...state, listLoading: action.payload.isLoading, lastCreatedAdjustmentId: undefined
            };
        case RetailBuildingAdjustmentsActionTypes.RetailBuildingAdjustmentActionToggleLoading:
            return {
                ...state, actionLoading: action.payload.isLoading
            };
        case RetailBuildingAdjustmentsActionTypes.RetailBuildingAdjustmentOnServerCreated:
            return {
                ...state
            };
        case RetailBuildingAdjustmentsActionTypes.RetailBuildingAdjustmentCreated:
            return adapter.addOne(action.payload.item, {
                ...state, lastCreatedAdjustmentsId: action.payload.item.id
            });
        case RetailBuildingAdjustmentsActionTypes.RetailBuildingAdjustmentUpdated:
            return adapter.updateOne(action.payload.partialItem, state);

        case RetailBuildingAdjustmentsActionTypes.AllRetailBuildingAdjustmentsLoaded:
            return adapter.addAll(action.payload.items, {
                ...state, isAllAdjustmentssLoaded: true
            });
        case RetailBuildingAdjustmentsActionTypes.RetailBuildingAdjustmentsPageCancelled:
            return {
                ...state, listLoading: false, queryRowsCount: 0, queryResult: [], lastQuery: new QueryParamsModel({})
            };
        case RetailBuildingAdjustmentsActionTypes.RetailBuildingAdjustmentsPageLoaded:
            return adapter.addMany(action.payload.items, {
                ...initialAdjustmentsState,
                totalCount: action.payload.totalCount,
                totalTrashed: action.payload.totalTrashed,
                totalAdminTrashed: action.payload.totalAdminTrashed,
                listLoading: false,
                lastQuery: action.payload.page,
                showInitWaitingMessage: false
            });

        case RetailBuildingAdjustmentsActionTypes.RetailBuildingAdjustmentDeleted:
            return adapter.removeOne(action.payload.id, {
                ...state, totalTrashed: state.totalTrashed + 1
            });

        case RetailBuildingAdjustmentsActionTypes.RetailBuildingAdjustmentRestored:
            return adapter.addOne(action.payload.item, {
                ...state, totalTrashed: state.totalTrashed - 1
            });

        case RetailBuildingAdjustmentsActionTypes.RetailBuildingAdjustmentDeletedFromTrash:
            return {
                ...state, totalTrashed: state.totalTrashed - 1, totalAdminTrashed: state.totalAdminTrashed + 1
            };

        // Admin Trash Action
        case RetailBuildingAdjustmentsActionTypes.RetailBuildingAdjustmentAdminRestored:
            return adapter.addOne(action.payload.item, {
                ...state, totalAdminTrashed: state.totalAdminTrashed - 1
            });

        case RetailBuildingAdjustmentsActionTypes.RetailBuildingAdjustmentDeletedFromAdminTrash:
            return {
                ...state, totalAdminTrashed: state.totalAdminTrashed - 1
            };
        case RetailBuildingAdjustmentsActionTypes.RetailBuildingAdjustmentTrashFlushed:
            return {
                ...state, totalTrashed: 0, totalAdminTrashed: state.totalAdminTrashed + state.totalTrashed
            };
        default:
            return state;
    }
}

export const {
    selectAll,
    selectEntities,
    selectIds,
    selectTotal
} = adapter.getSelectors();